/**
 * Copyright © Veeam Software Group GmbH.
 */


import { UserTitleRepresentation } from '@veeam-vspc/models/web-controllers';

export type UserTitle = UserTitleRepresentation;
export const UserTitle = UserTitleRepresentation;
